export default {"src":"/uk/_next/static/media/summaryIconYellow.b55b8bf0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};